import { BarcodeSearch } from 'components/barcode'
import { LpDetails } from 'components/item-verification'
import { TripContext } from 'contexts'
import notify from 'devextreme/ui/notify'
import React, { FC, Fragment, useContext } from 'react'
import { useLicensePlateService, useNavigation, useOrderItemService, useParamService } from 'services'
import { VerifiedMethod } from 'services/enums'
import { LicensePlate, OrderItem } from 'services/types'
import './lp-details-page.scss'


export const LpDetailsPage: FC = () => {

    const { getIntValue } = useParamService
    const { navigateTo } = useNavigation()
    const { verifyLp, areAllLpItemsVerified } = useLicensePlateService()
    const { verifyItem } = useOrderItemService()
    const tripContext = useContext(TripContext)

    const lpId: number | undefined = getIntValue('lpId')
    const licensePlate: LicensePlate = tripContext.licensePlates.find(lp => lp.id === lpId) ?? {} as LicensePlate
    const tripId: number | undefined = tripContext.stops.find(s => s.id === licensePlate.stopId)?.tripId
    const stopId: number | undefined = licensePlate.stopId
    const lpItems = tripContext.licensePlateItems.filter(lpi => lpi.licensePlateId === lpId)

    const onDetailsClicked = async (item: OrderItem) => {
        await navigateTo(`item-details?orderItemId=${item?.id}`)
    }

    const onVerifyClicked = async (orderItem: OrderItem) => {
        if (areAllLpItemsVerified([licensePlate], orderItem.lineItemId)) {
            await verifyItem(orderItem, VerifiedMethod.Manual)
        }
        await navigateTo(`verify-item?stopId=${stopId}&itemId=${orderItem.lineItemId}`)
    }

    const handleVerifyLp = async () => {
        if (lpId) {
            await verifyLp(lpId, VerifiedMethod.Manual)
            notify(`${licensePlate.temperature} License Plate ${licensePlate.id} verified`, 'success', 5000)
        }
    }

    return (
        <Fragment>
            <BarcodeSearch tripId={tripId} stopId={stopId} />
            <LpDetails
                licensePlateId={lpId}
                onVerify={handleVerifyLp}
                onDetailsClicked={onDetailsClicked}
                onVerifyClicked={onVerifyClicked}
            />
        </Fragment>
    )
}